import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/legal/agb")({
  head: () => ({ meta: [{ title: "AGB — NexKey.gg" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <article>
      <h1 className="font-display text-3xl font-bold">Allgemeine Geschäftsbedingungen</h1>
      <p className="mt-4 text-sm text-muted-foreground">
        Placeholder. Replace with your terms of service before going live.
      </p>
    </article>
  ),
});
